// ArticleTemplate.js
import React from "react";
import { Typography, Container, Box } from "@mui/material";
import "../pages/articles/Article.css";
import ReadAloud from "./ReadAloud";

const ArticleTemplate = ({ title, content }) => {
  return (
    <Container maxWidth="md">
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom className="article-title">
          {title}
        </Typography>
        <ReadAloud content={content.join("\n\n")} />
        <br></br><br></br>
        {content.map((paragraph, index) => (
          <p key={index} variant="body1" paragraph className="article-content">
            {paragraph}
          </p>
        ))}
      </Box>
    </Container>
  );
};

export default ArticleTemplate;
